import { render, staticRenderFns } from "./LLFileModalVideo.vue?vue&type=template&id=3b145ae8&scoped=true"
import script from "./LLFileModalVideo.vue?vue&type=script&lang=js"
export * from "./LLFileModalVideo.vue?vue&type=script&lang=js"
import style0 from "./LLFileModalVideo.vue?vue&type=style&index=0&id=3b145ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b145ae8",
  null
  
)

export default component.exports